'use client'

import React from 'react'
import Icon, { IconName } from '@dustin-web/microsite-components/src/icon'

// This is a workaround for dynamic imports that seems to be bundled incorrectly (?) in next / react server components
// TODO: Remove this when the issue is fixed
export const IconClient = ({ name, ...props }: { name: IconName }) => {
  return <Icon name={name} {...props} />
}
